"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderImage = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const renderImage = props => {
  const {
    GatsbyImage,
    src,
    alt,
    image,
    className,
    lazyLoad = true,
    contentfulId
  } = props;
  const loadSetting = lazyLoad === false ? "eager" : "lazy";
  const sbProps = contentfulId ? {
    "data-sb-object-id": contentfulId
  } : null;
  if (GatsbyImage && image) {
    return /*#__PURE__*/_react.default.createElement(GatsbyImage, {
      image: image,
      className: className,
      alt: alt ? alt : "",
      loading: loadSetting
    });
  } else if (!GatsbyImage && src) {
    return /*#__PURE__*/_react.default.createElement("img", _extends({
      src: src,
      alt: alt ? alt : "",
      className: className,
      loading: loadSetting
    }, sbProps));
  } else {
    return;
  }
};
exports.renderImage = renderImage;